var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(
      _vm.isAuthenticated & (_vm.$route.name != 'WatchNarrative') &&
        _vm.$route.name != 'Dashboard'
    )?_c('nav-bar',{staticClass:"sticky top-0",staticStyle:{"z-index":"2000"}}):_vm._e(),(_vm.errorsPresent)?_c('error-modal',{attrs:{"message":_vm.errorMessage}}):_vm._e(),(_vm.messageIsVisible)?_c('message-modal',{attrs:{"messageData":_vm.messageData}}):_vm._e(),_c('router-view',{on:{"error":_vm.showErrors}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }